<!-- <mat-card class="p-2">
<table>
  <thead>
    <tr>
      <td style="width: 15%;"></td>
      <td class="fs-4 text-weight text-center">Total</td>
      <td class="fs-4 text-weight text-center" *ngFor="let item of operationalDetails">{{ orderType[item.orderType] }}
      </td>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="fs-5">Number of Orders</td>
      <td class="text-center td-total-bg-color text-white">{{ numberofOrders | number: '1.0-0' }}</td>
      <td *ngFor="let item of operationalDetails" class="text-center td-bg-color text-white">
        {{ item.totalOrders | number: '1.0-0' }}
      </td>
    </tr>

    <tr>
      <td class="fs-5">Total Revenue</td>
      <td class="text-center td-total-bg-color text-white">{{ totalRevenue | number: '1.0-0' }}</td>
      <td *ngFor="let item of operationalDetails" class="text-center td-bg-color text-white">
        {{ item.totalRevenue | number: '1.0-0' }}
      </td>
    </tr>
    @if (role != 'Manager') {
      <tr>
        <td class="fs-5">Total Profit</td>
        <td class="text-center td-total-bg-color text-white">{{ totalProfit | number: '1.0-0' }}</td>
        <td *ngFor="let item of operationalDetails" class="text-center td-bg-color text-white">
          {{ item.totalProfit | number: '1.0-0' }}
        </td>
      </tr>
    }
  </tbody>

</table>
</mat-card> -->
<mat-card class="p-2">
  <table class="table-responsive">
    <thead>
      <tr>
        <td style="width: 15%;"></td>
        <td class="fs-5 fs-md-4 text-weight text-center">Total</td>
        @for (item of operationalDetails; track item) {
          <td class="fs-5 fs-md-4 text-weight text-center">{{ orderType[item.orderType] }}</td>
        }
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="fs-6 fs-md-5">Number of Orders</td>
        <td class="text-center td-total-bg-color text-white">{{ numberofOrders | number: '1.0-0' }}</td>
        @for (item of operationalDetails; track item) {
          <td class="text-center td-bg-color text-white">
            {{ item.totalOrders | number: '1.0-0' }}
          </td>
        }
      </tr>

      <tr>
        <td class="fs-6 fs-md-5">Total Revenue</td>
        <td class="text-center td-total-bg-color text-white">{{ totalRevenue | number: '1.0-0' }}</td>
        @for (item of operationalDetails; track item) {
          <td class="text-center td-bg-color text-white">
            {{ item.totalRevenue | number: '1.0-0' }}
          </td>
        }
      </tr>

      @if (role !== 'Manager') {
        <tr>
          <td class="fs-6 fs-md-5">Total Profit</td>
          <td class="text-center td-total-bg-color text-white">{{ totalProfit | number: '1.0-0' }}</td>
          @for (item of operationalDetails; track item) {
            <td class="text-center td-bg-color text-white">
              {{ item.totalProfit | number: '1.0-0' }}
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</mat-card>
